export interface OrganizationPagePaths {
  /**
   * The normalized current path.
   */
  path: string;
  /**
   * The canonical organization path built from the first two URL segments.
   */
  organizationPath: string;
  /**
   * The nested path segments after the organization path, joined by slashes.
   */
  subPath: string;
  /**
   * Whether the current path points to a nested organization subpage.
   */
  hasNestedPath: boolean;
}

export const getOrganizationPagePaths = (
  path: string,
): OrganizationPagePaths => {
  const cleanPath = path || '/';
  // Split the URL into meaningful segments, ignoring leading/trailing slashes.
  const pathParts = cleanPath.split('/').filter(Boolean);

  return {
    path: cleanPath,
    // Organization pages use the first two segments as their canonical path.
    organizationPath:
      pathParts.length >= 2 ? `/${pathParts[0]}/${pathParts[1]}` : cleanPath,
    // Any segments after the organization path represent a nested subpage.
    subPath: pathParts.slice(2).join('/'),
    hasNestedPath: pathParts.length > 2,
  };
};
